export default __webpack_public_path__ + "static/media/landing-test-poster.a1101c33.png";